export const API_END_POINT = `${process.env.REACT_APP_API_URL}/api`;
export const API_VERSION = '/v1';
export const END_POINTS = {
  AUTH: {
    SEND_OTP: '/auth/send-otp',
    VERIFY_OTP: '/auth/verify-otp',
    REFRESH: '/auth/refresh-token',
    USER: '/user/me'
  },
  GREETING: '/greeting',
  QUESTION: {
    QUESTION_PREVIEW: ({ questionId }: { questionId: string }) =>
      `/question/preview/${questionId}`
  },
  HOMEWORKS: {
    GET_QUESTION_MAPPING: (assignmentId: string) =>
      `/homework/${assignmentId}/question-mappings`,
    GET_QUESTION_DETAILS: ({
      assignmentId,
      questionId
    }: {
      assignmentId: string;
      questionId: string;
    }) => `/homework/${assignmentId}/question/${questionId}`,
    GET_FILE_UPLOAD_LINK: '/file/upload-url',
    HOMEWORK_LIST: 'homework',
    HOMEWORK_DETAILS: (assignmentId: string) => `/homework/${assignmentId}`,
    START_HOMEWORK: (assignmentId: string) => `/homework/${assignmentId}/start`,
    SUBMIT_ANSWER: (assignmentId: string, questionId: string) =>
      `homework/${assignmentId}/question/${questionId}/submit`,
    HOMEWORK_SUMMARY: (assignmentId: string) =>
      `/homework/${assignmentId}/summary`,
    OVERALL_PERFORMANCE: (assignmentId: string) =>
      `/homework/${assignmentId}/overall-performance`,
    HOMEWORK_SUMMARY_BY_STUDENT_ID: (assignmentId: string, studentId: string) =>
      `/homework/${assignmentId}/student/${studentId}/summary`,
    OVERALL_PERFORMANCE_BY_STUDENT_ID: (
      assignmentId: string,
      studentId: string
    ) => `/homework/${assignmentId}/student/${studentId}/overall-performance`,
    HOMEWORK_DETAILS_BY_STUDENT_ID: (assignmentId: string, studentId: string) =>
      `/homework/${assignmentId}/student/${studentId}`,
    GET_QUESTION_DETAILS_BY_STUDENT_ID: ({
      assignmentId,
      questionId,
      studentId
    }: {
      assignmentId: string;
      questionId: string;
      studentId: string;
    }) =>
      `/homework/${assignmentId}/question/${questionId}/student/${studentId}`,
    HOMEWORK_ASSIGNED: (title: string) =>
      `/homework?listType=ACTIVE_OVERDUE&limit=3${
        title ? `&title=${title}` : ''
      }`,
    // POST /homework/question/:questionId/flag
    FLAG_QUESTION: (questionId: string) =>
      `/homework/question/${questionId}/flag`,
    REPORTS_STUDENT_TOPIC_SKILL_PERFORMANCE: (studentId: string) =>
      `/assignment-report/student/${studentId}/topic-skill-performance`,
    REPORTS_STUDENT_OVERVIEW: (studentId: string) =>
      `/assignment-report/student/${studentId}/overview`,
    REPORTS_STUDENT_SUPPLIMENTARY_ACTIVITY: (studentId: string) =>
      `/assignment-report/student/${studentId}/supplementary-learning`,
    REPORTS_STUDENT_STRENGTH_WEAKNESS: (studentId: string) =>
      `/assignment-report/student/${studentId}/strengths-weaknesses`,
    REPORTS_STUDENT_HOMEWORK_TOPIC_SKILL_PERFORMANCE: (assignmentId: string) =>
      `/assignment-report/homework/${assignmentId}/student/topic-skill-performance`,
    REPORTS_STUDENT_HOMEWORK_OVERVIEW: (assignmentId: string) =>
      `/assignment-report/homework/${assignmentId}/student/overview`,
    REPORTS_STUDENT_HOMEWORK_SUPPLIMENTARY_ACTIVITY: (assignmentId: string) =>
      `/assignment-report/homework/${assignmentId}/student/supplementary-learning`
  },
  DASHBOARD: {
    STUDENT_LEVEL_PREVIEW: (subjectId: string) =>
      `/gamification/student/summary${
        subjectId ? `?subjectId=${subjectId}` : ''
      }`,
    STUDENT_TOTAL_XP: '/gamification/student/total-xp'
  },
  SETTINGS: {
    SUBMIT_FEEDBACK: '/settings/feedback',
    GET_FILE_UPLOAD_LINK: '/file/upload-url',
    CONTACT_SUPPORT: '/settings/support-request',
    DELETE_ACCOUNT: '/user/delete',
    GET_FAQ_LIST: '/settings/faq',
    USER_SUPPORT_REQUEST: '/settings/support-request/me',
    STUDENT_DETAILS: '/student'
  },
  PARENT: {
    GET_HOMEWORKS_BY_STUDENT_ID: (studentId: string) =>
      `/homework/student/${studentId}`,
    STUDENT_AVG_SCORE_TIME: (studentId: string) =>
      `/assignment-report/parent/student/${studentId}/average-score-time`,
    STUDENT_FEEDBACK_RECOMMENDATION: (studentId: string) =>
      `/assignment-report/parent/student/${studentId}/feedback-recommendation`,
    STUDENT_HOMEWORK_COMPLETION_RATE: (studentId: string, subjectId?: string) =>
      `/assignment-report/parent/student/${studentId}/completion-rate${
        subjectId ? `?subjectId=${subjectId}` : ''
      }`,
    STUDENT_SKILL_REPORT: (studentId: string) =>
      `/assignment/parent/skills-report/student/${studentId}`,
    STUDENT_SCORE_TREND_OVER_TIME: (studentId: string) =>
      `/assignment-report/parent/student/${studentId}/homework-score-trend`,
    STUDENT_REPORT_HOMEWORK_SCORE_LIST: (studentId: string) =>
      `/assignment-report/parent/student/${studentId}/homework-score-list`,
    STUDENT_SUBJECT_LIST: (studentId: string) =>
      `/student/${studentId}/subject`,
    STUDENT_MASCOTS: (studentId: string) => `/student/${studentId}/mascots`,
    STUDENT_LEADERBOARD_SUMMARY: (studentId: string) =>
      `/gamification/parent/student/${studentId}/summary`,
    STUDENT_PROGRESS_OVERVIEW: (
      studentId: string,
      fromDate: string,
      toDate: string
    ) =>
      `assignment-report/parent/student/${studentId}/progress-overview?fromDate=${fromDate}&toDate=${toDate}`,
    STUDENT_TOTAL_PROGRESS_OVERVIEW: `assignment-report/student/total-progress`
  },
  LEADERBOARD: {
    GET_LEADERBOARD: '/gamification/student/leaderboard',
    GET_STUDENT_SUBJECTS: '/student/subjects',
    LEADERBOARD_STUDENT_SUMMARY: '/gamification/student/summary',
    STAGE_NOTIFIED: '/gamification/update-stage-notified'
  },
  MASCOT: {
    STUDENT_MASCOTS: '/student/mascots',
    GET_ALL_MASCOTS: 'mascot/image'
  },
  NOTICES: {
    NOTICES: (studentId: string) =>
      `/notices${studentId ? `?studentId=${studentId}` : ''}`,
    ACKNOWLEDGE: (id: string) => `/notices/${id}/acknowledge`
  },
  CHAT: {
    RECENT_CHATS: '/chat/threads'
  },
  CALENDAR: {
    GET_DATA: (
      startDate: string,
      endDate: string,
      studentId: string,
      timezone?: string
    ) => {
      const userTimezone =
        timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
      const baseUrl = `/events?timezone=${userTimezone}${
        startDate && `&startDate=${startDate}`
      }${endDate && `&endDate=${endDate}`}`;
      if (!studentId) return baseUrl;

      return `${baseUrl}&studentIds=${studentId}`;
    },
    CREATE: '/events',
    UPDATE_DELETE: (originalEventId: string) => `/events/${originalEventId}`
  }
};
